
import { useState } from "react";
import  "./AftertasteIntensity.css";

const AftertasteIntensity = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.aftertestduration===0?0:data.aftertestduration);
  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="AftertasteIntensityradiocard" name ="aftertestduration" onChange={onChangeValue}>
    <div class="AftertasteIntensityrating-container">
      
      <div class="AftertasteIntensityrating">
        <form class="AftertasteIntensityrating-form-1" >

          <label for={`AFI1F-${count}`}>
        <input type="radio"  name="aftertestduration" class="AftertasteIntensity1" id={`AFI1F-${count}`}  value="1"  checked={'' + val === "1"} />
        <div className="circle">1</div>
        </label>

          <label for={`AFI2F-${count}`}>
        <input type="radio" name="aftertestduration" class="AftertasteIntensity2" id={`AFI2F-${count}`} value="2" checked={'' + val === "2"} />
       <div className="circle">2</div>
        </label>

          <label for={`AFI3F-${count}`}>
        <input type="radio" name="aftertestduration" class="AftertasteIntensity3" id={`AFI3F-${count}`} value="3" checked={'' + val === "3"} />
       <div className="circle">3</div>

        </label>

          <label for={`AFI4F-${count}`}>
        <input type="radio" name="aftertestduration" class="AftertasteIntensity4" id={`AFI4F-${count}`} value="4" checked={'' + val === "4"} />
        <div className="circle">4</div>

        </label>

          <label for={`AFI5F-${count}`}>
        <input type="radio" name="aftertestduration" class="AftertasteIntensity5" id={`AFI5F-${count}`} value="5" checked={'' + val === "5"} />
        <div className="circle">5</div>
                </label>
        </form>
      </div>
    </div>
  </div>


    );
}

export default AftertasteIntensity;